module.exports = __webpack_public_path__ + "static/img/logo60.f3ba927.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo60.png
// module id = y6MX
// module chunks = 1